export enum AuthType {
  PUBLIC = 'PUBLIC',
  PROTECTED = 'PROTECTED',
}

export interface StoreProgramPublicDetails {
  id: string
  brandLogoUrl: string
  loginPageMessage: string
  slug: string
  clientName: string
  authType: AuthType
}

export interface StoreProgramResponse {
  id: number
  name: string
  storeProgramType: string
  storeId: number
  clientId: number
  client: Client
  regionId: number
  storeProgramDetails: StoreProgramDetails
  storeProgramConfig: StoreProgramConfig
  status: string
  startTime: string
  endTime: string
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
}

export interface Client {
  id: number
  name: string
  code: string
}

export interface StoreProgramDetails {
  id: number
  storeProgramId: number
  slug: string
  brandLogoUrl: string
  storefrontUrl: string
  adminEmail: string
  billingAddressId: string
  storefrontContent: StorefrontContent
}

export interface StorefrontContent {
  loginPageMessage: string
  collectionListingPageSubText: string
  storefrontPageContents?: StorefrontPageContent[]
  contentFulId?: string
  title?: string
}

export interface StorefrontPageContent {
  key: string
  title: string
  description: string
  displayPage: StorefrontPageDisplayPage[]
}

export enum StorefrontPageDisplayPage {
  PDP = 'PDP',
  CUSTOMIZATION = 'CUSTOMIZATION',
}

export interface StoreProgramConfig {
  id: number
  storeProgramId: number
  fundingType: string
  maxUnitsPerOrder: number
  authType: AuthType
  maxItemsPerLineItem?: number
  isFinalSale: boolean
  isOrderSharingEnabled: boolean
  isQuinceOwnedSelfService: boolean
  isCustomisationAllowed?: boolean
}
